import React, { PureComponent } from 'react';
import { showModal } from '../actions/modal';

export default class CustomFieldsUpgradeNotice extends PureComponent {
    handleUpgradeClick = () => {
        showModal('SWITCH_PLAN');
    }

    render() {
        return (
            <p className="custom-field-upgrade-notice dimmed-text">
                <button className="btn btn-link btn-link-underlined btn-colored" onClick={this.handleUpgradeClick}>Upgrade</button> to add custom fields and specify custom data for your projects.<br />

                <a href="http://help.niftypm.com/en/articles/3938415-custom-fields-types-for-project-management" target="_blank" rel="noopener noreferrer">Learn more!</a>
            </p>
        )
    }
}